import React, { useState } from 'react';
import AppointmentCard from 'components/AppointmentCard';
import TextVisitCard from 'components/TextVisitCard';
import s from './s.module.less';
import { Button, Tabs, Popover, Modal, Input, message } from 'antd';
import CancelRecurringRefillModal from 'components/CancelRecurringRefillModal';
import { EServiceType, KlarityService, Prospect, TAppointmentItem } from 'types/common';
import { CaseListItem } from 'types/textVisit';
import { openTextVisitUnSubmittedDrawer, openTextVisitSubmittedDrawer, openVideoVisitUnSubmittedDrawer, openVideoVisitSubmittedDrawer } from 'utils/globalLayerControl';
// eslint-disable-next-line import/no-cycle
import AddAndEditCalendarEventModal from 'components/AddAndEditCalendarEvent/Modal';
import useProviderKlarityServiceList from 'hooks/useProviderKlarityServiceList';
import useKlarityServiceTemplate from 'hooks/useKlarityServiceTemplate';
import ChargeModal from 'pages/dashboard/ProspectsDetailPage/components/prosepectInfo/components/ChargeModal';
import { getUserId } from 'utils/localstore';
import { useGetConnectAccountInfo } from 'hooks/useGetConnectAccountInfo';
import { useBillingPolicy } from 'hooks/paymentSetup/useBillingPolicy';
import { textVisitDecline } from 'api/provider';
import IntakeFormDrawer from 'components/IntakeFormDrawer';
import useGetCaseDetail from 'hooks/textVisit/useGetCaseDetail';
import useTreatmentAppointmentDetail from 'hooks/treatment/useTreatmentAppointmentDetail';

export interface AppointmentItem {
    status?: string;
    title: string;
    date: number;
    time: number;
    duration: number;
    teleHealthLink: string;
    visitReason: string;
    onView?: () => void;
}

type Props = {
    activeTab: 'InProgress' | 'PastDue' | 'Upcoming' | 'Past';
    setActiveTab: (tab: 'InProgress' | 'PastDue' | 'Upcoming' | 'Past') => void;
    data: any[];
    onNextPage?: (type: 'InProgress' | 'PastDue' | 'Upcoming' | 'Past') => void;
    showMoreButton?: boolean;
    loading?: boolean;
    countsReady?: boolean;
    upcomingCount: number;
    pastCount: number;
    inProgressCount: number;
    pastDueCount?: number;
    smallSize?: boolean;
    showCreateVisitAction?: boolean;
    clientId?: number;
    onUpdate?: () => void;
    isInTextVisitPop?: boolean;
    onVisitCreated?: (serviceType?: EServiceType) => void;
    isGroupPractice?: boolean;
    client?: Prospect;
    useInModule?: boolean;
};

const ListContent = (props: Props) => {
    const {
        activeTab,
        setActiveTab,
        data,
        onNextPage,
        showMoreButton = true,
        loading,
        countsReady = false,
        upcomingCount = 0,
        pastCount = 0,
        inProgressCount = 0,
        pastDueCount = 0,
        smallSize = false,
        showCreateVisitAction = false,
        clientId,
        onUpdate,
        isInTextVisitPop,
        onVisitCreated,
        isGroupPractice,
        client,
        useInModule,
    } = props;
    const TABS = React.useMemo(() => {
        const tabs: { key: Props['activeTab']; label: string }[] = [];
        if (inProgressCount > 0) tabs.push({ key: 'InProgress', label: `In-progress (${inProgressCount})` });
        if (pastDueCount > 0) tabs.push({ key: 'PastDue', label: `Past due (${pastDueCount})` });
        if (useInModule) {
            if (upcomingCount > 0) tabs.push({ key: 'Upcoming', label: `Upcoming (${upcomingCount})` });
        } else {
            tabs.push({ key: 'Upcoming', label: `Upcoming (${upcomingCount})` });
        }
        tabs.push({ key: 'Past', label: `Past (${pastCount})` });
        return tabs;
    }, [inProgressCount, pastDueCount, upcomingCount, pastCount, useInModule]);
    const [showAddVisitModal, setShowAddVisitModal] = React.useState(false);
    const [visitServiceType, setVisitServiceType] = React.useState<string>();
    const [editingRecurrenceSeriesId, setEditingRecurrenceSeriesId] = React.useState<number | undefined>(undefined);
    const [editingTextVisitId, setEditingTextVisitId] = React.useState<number | undefined>(undefined);
    const [editingTextVisitData, setEditingTextVisitData] = React.useState<
        { clientId?: number; specialty?: string; startAt?: string } | undefined
    >(undefined);
    const [providerServiceList] = useProviderKlarityServiceList();
    const [serviceTypeOptions, setServiceTypeOptions] = React.useState<string[]>([]);
    const [allSpeciality, setAllSpeciality] = React.useState<KlarityService[]>([]);
    const [template] = useKlarityServiceTemplate(); //for load speciality
    const [currentDeclineRefilleItem, setCurrentDeclineRefilleItem] = React.useState<CaseListItem | null>(null);
    const [showChargePatientModal, setShowChargePatientModal] = React.useState(false);
    const [showDeclineRefilleModal, setShowDeclineRefilleModal] = React.useState(false);
    const [showCancelRecurringModal, setShowCancelRecurringModal] = React.useState(false);
    const [declineRefilleReason, setDeclineRefilleReason] = React.useState('');
    const [sendingDeclineRefilleMessage, setSendingDeclineRefilleMessage] = React.useState(false);
    const [cancelRecurringCtx, setCancelRecurringCtx] = React.useState<{
        textVisitId?: number;
        patientName?: string;
    } | null>(null);
    const [connectAccountInfo] = useGetConnectAccountInfo();
    const [billingPolicy] = useBillingPolicy(false, getUserId());
    const [showIntakeFormDrawer, setShowIntakeFormDrawer] = React.useState(false);
    const [currentItemType, setCurrentItemType] = React.useState<'TEXT_VISIT' | 'APPOINTMENT'>();
    const [currentTextvisitId, setCurrentTextvisitId] = useState<string>();
    const [currentAppointmentId, setCurrentAppointmentId] = useState<number>();
    const [textVisitDetail] = useGetCaseDetail({
        caseUuid: currentTextvisitId,
    });
    //for
    const [targetProviderId, setTargetProviderId] = React.useState<number | undefined>(undefined);
    const [appointmentTreatmentDetail] = useTreatmentAppointmentDetail(currentAppointmentId);
    React.useEffect(() => {
        if (!countsReady) return;
        if (useInModule) {
            const visibleTabs: Props['activeTab'][] = [];
            if (inProgressCount > 0) visibleTabs.push('InProgress');
            if (pastDueCount > 0) visibleTabs.push('PastDue');
            if (upcomingCount > 0) visibleTabs.push('Upcoming');
            visibleTabs.push('Past');
            if (!visibleTabs.includes(activeTab)) {
                setActiveTab(visibleTabs[0]);
            }
        } else {
            const hasInProgress = inProgressCount > 0;
            const hasPastDue = pastDueCount > 0;
            if (activeTab === 'InProgress' && !hasInProgress) {
                setActiveTab('Upcoming');
            }
            if (activeTab === 'PastDue' && !hasPastDue) {
                setActiveTab(hasInProgress ? 'InProgress' : 'Upcoming');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countsReady, inProgressCount, pastDueCount, upcomingCount, useInModule]);

    React.useEffect(() => {
        if (currentDeclineRefilleItem) {
            setDeclineRefilleReason(
                `Hi ${currentDeclineRefilleItem?.patientFirstName || currentDeclineRefilleItem?.patientLastName}, I’m unable to fulfill this prescription refill at this time. Please book a visit so we can review your request and discuss next steps.`,
            );
        }
    }, [currentDeclineRefilleItem]);

    React.useEffect(() => {
        if (template) {
            const allData: KlarityService[] = [...(template?.recommend || []), ...(template?.other || [])];
            setAllSpeciality(allData);
        }
    }, [template]);

    React.useEffect(() => {
        if (providerServiceList) {
            const _serviceTypeOptions: string[] = [];
            providerServiceList.forEach((item) => {
                if (!_serviceTypeOptions.includes(item.serviceType)) {
                    _serviceTypeOptions.push(item.serviceType);
                }
            });
            setServiceTypeOptions(_serviceTypeOptions);
        }
    }, [providerServiceList]);

    const handleDeclineRefille = async () => {
        setSendingDeclineRefilleMessage(true);
        const res = await textVisitDecline(currentDeclineRefilleItem?.id!, declineRefilleReason);
        setSendingDeclineRefilleMessage(false);
        if (!res.error) {
            message.success('Refill request declined successfully');
            setShowDeclineRefilleModal(false);
            setCurrentDeclineRefilleItem(null);
            setDeclineRefilleReason('');
            onUpdate?.();
        }
    };

    return (
        <div className={`${s.listContentWrapper} ${useInModule ? s.moduleMode : ''}`}>
            <div className={s.tabs}>
                <div className={s.tabItem}>
                    {useInModule && TABS.length === 1 ? (
                        <div className={s.singleTabTitle}>
                            {TABS[0]?.label}
                        </div>
                    ) : (
                        <Tabs
                            items={TABS}
                            activeKey={activeTab}
                            onChange={(key) => setActiveTab(key as Props['activeTab'])}
                        />
                    )}
                </div>
                {showCreateVisitAction && (
                    <div className={s.tabAction}>
                        <Popover
                            content={
                                <div className={s.popList}>
                                    {serviceTypeOptions.includes(EServiceType.ESTABLISHED_PATIENT_VISIT) && (
                                        <p
                                            onClick={() => {
                                                setVisitServiceType(EServiceType.ESTABLISHED_PATIENT_VISIT);
                                                setShowAddVisitModal(true);
                                            }}
                                        >
                                            New established patient visit
                                        </p>
                                    )}
                                    {serviceTypeOptions.includes(EServiceType.PRESCRIPTION_SERVICE) && (
                                        <p
                                            onClick={() => {
                                                setVisitServiceType(EServiceType.PRESCRIPTION_SERVICE);
                                                setShowAddVisitModal(true);
                                            }}
                                        >
                                            New prescription refill visit
                                        </p>
                                    )}
                                    {serviceTypeOptions.includes(EServiceType.INIT) && (
                                        <p
                                            onClick={() => {
                                                setVisitServiceType(EServiceType.INIT);
                                                setShowAddVisitModal(true);
                                            }}
                                        >
                                            New initial visit
                                        </p>
                                    )}
                                </div>
                            }
                            title={null}
                            trigger="hover"
                            placement="bottomRight"
                        >
                            <div className={s.tabBtn} onClick={() => {}}>
                                New visit
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                >
                                    <path
                                        d="M12.6667 1L6.83333 6.83333L1 1"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </Popover>
                    </div>
                )}
            </div>
            <div className={s.cards}>
                {data.length === 0 ? (
                    <div className={s.empty}>No appointments</div>
                ) : (
                    data.map((item, idx) =>
                        item.textVisitUuid ? (
                            <TextVisitCard
                                key={idx}
                                activeTab={activeTab}
                                caseData={item as CaseListItem}
                                onViewDetails={() => {
                                    const gpProviderId = isGroupPractice
                                        ? (item as CaseListItem).provider?.providerId
                                        : undefined;
                                    if (!item.providerTreatmentSubmitted) {
                                        openTextVisitUnSubmittedDrawer(
                                            item.textVisitUuid,
                                            () => onUpdate?.(),
                                            true,
                                            gpProviderId,
                                            isGroupPractice,
                                        );
                                    } else {
                                        openTextVisitSubmittedDrawer(item.textVisitUuid, gpProviderId);
                                    }
                                }}
                                smallSize={smallSize}
                                clientId={clientId}
                                onDeclineRefilleRequest={(tvItem: CaseListItem) => {
                                    setCurrentDeclineRefilleItem(tvItem);
                                    setShowDeclineRefilleModal(true);
                                }}
                                onCancelRecurringRequest={(tvItem: CaseListItem) => {
                                    setCancelRecurringCtx({
                                        textVisitId: tvItem.id,
                                        patientName:
                                            `${tvItem.patientFirstName || ''} ${tvItem.patientLastName || ''}`.trim(),
                                    });
                                    setShowCancelRecurringModal(true);
                                }}
                                onEditRequest={(tvItem: CaseListItem) => {
                                    const recurrenceId = (tvItem as any)?.recurrenceId ?? (tvItem as any)?.recurrentId;
                                    if (recurrenceId) {
                                        setEditingRecurrenceSeriesId(recurrenceId);
                                        setVisitServiceType(undefined);
                                        setShowAddVisitModal(true);
                                        setTargetProviderId(tvItem.provider?.providerId);
                                        return;
                                    }
                                    if (tvItem?.id) {
                                        setEditingTextVisitId(tvItem.id);
                                        setEditingTextVisitData({
                                            clientId: tvItem.clientId,
                                            specialty: (tvItem as any)?.specialty,
                                            startAt: tvItem.startAt,
                                        });
                                        setVisitServiceType(undefined);
                                        setShowAddVisitModal(true);
                                    }
                                }}
                                onChargePatient={() => {
                                    setShowChargePatientModal(true);
                                }}
                                showChargeAction={activeTab === 'Past'}
                                hideViewDetails={isInTextVisitPop}
                                onViewIntakeForm={() => {
                                    setCurrentItemType('TEXT_VISIT');
                                    setCurrentTextvisitId(item.textVisitUuid);
                                    setShowIntakeFormDrawer(true);
                                }}
                                isGroupPractice={isGroupPractice}
                                useInModule={useInModule}
                            />
                        ) : (
                            <AppointmentCard
                                listTab={activeTab}
                                useInModule={useInModule}
                                onViewIntakeForm={() => {
                                    setCurrentItemType('APPOINTMENT');
                                    setCurrentAppointmentId(item.id);
                                    setShowIntakeFormDrawer(true);
                                }}
                                onViewVisitNotes={() => {
                                    if (item.providerTreatmentSubmitted) {
                                        openVideoVisitSubmittedDrawer(item.id);
                                    } else {
                                        openVideoVisitUnSubmittedDrawer(item.id, () => onUpdate?.());
                                    }
                                }}
                                onCancelRecurring={(apptItem) => {
                                    const anyItem = apptItem as any;
                                    const tvId = anyItem?.textVisitId;
                                    const name =
                                        anyItem?.patientName ||
                                        `${anyItem?.patientFirstName || ''} ${anyItem?.patientLastName || ''}`.trim();
                                    setCancelRecurringCtx({
                                        textVisitId: tvId,
                                        patientName: name,
                                    });
                                    setShowCancelRecurringModal(true);
                                }}
                                clientId={clientId}
                                key={idx}
                                item={item as TAppointmentItem}
                                client={client}
                                isGroupPractice={isGroupPractice}
                            />
                        ),
                    )
                )}
            </div>
            {showMoreButton && (
                <div className={s.moreButton}>
                    <Button loading={loading} onClick={() => onNextPage?.(activeTab)}>
                        View more appointments
                    </Button>
                </div>
            )}
            {showAddVisitModal && (
                <AddAndEditCalendarEventModal
                    allSpecialityData={allSpeciality}
                    isGroupPractice={isGroupPractice}
                    onCancel={() => {
                        setShowAddVisitModal(false);
                        setEditingRecurrenceSeriesId(undefined);
                        setEditingTextVisitId(undefined);
                        setEditingTextVisitData(undefined);
                        setTargetProviderId(undefined);
                    }}
                    onSuccess={(serviceType?: EServiceType) => {
                        const isEditing = !!editingRecurrenceSeriesId || !!editingTextVisitId;
                        setShowAddVisitModal(false);
                        setEditingRecurrenceSeriesId(undefined);
                        setEditingTextVisitId(undefined);
                        setEditingTextVisitData(undefined);
                        onUpdate?.();
                        setTargetProviderId(undefined);
                        if (!isEditing) {
                            onVisitCreated?.(serviceType);
                        }
                    }}
                    hideAddBlock
                    targetServiceType={visitServiceType as EServiceType}
                    targetClientId={editingRecurrenceSeriesId || editingTextVisitId ? undefined : clientId}
                    recurrenceSeriesId={editingRecurrenceSeriesId}
                    editingTextVisitId={editingTextVisitId}
                    editingTextVisitData={editingTextVisitData}
                    targetProviderId={targetProviderId}
                />
            )}
            <Modal
                okText="Send message"
                okButtonProps={{
                    loading: sendingDeclineRefilleMessage,
                }}
                open={showDeclineRefilleModal}
                title="Unable to fulfill prescription refill request"
                onOk={handleDeclineRefille}
                onCancel={() => {
                    setShowDeclineRefilleModal(false);
                    setCurrentDeclineRefilleItem(null);
                    setDeclineRefilleReason('');
                }}
            >
                <div className={s.mWrap}>
                    <p>
                        You won’t be able to prescribe this medication for this patient. Please select a reason and
                        notify the patient.
                    </p>
                    <Input.TextArea
                        rows={4}
                        value={declineRefilleReason}
                        onChange={(e) => setDeclineRefilleReason(e.target.value)}
                    />
                </div>
            </Modal>

            <CancelRecurringRefillModal
                open={showCancelRecurringModal}
                textVisitId={cancelRecurringCtx?.textVisitId}
                patientName={cancelRecurringCtx?.patientName}
                onClose={() => {
                    setShowCancelRecurringModal(false);
                    setCancelRecurringCtx(null);
                }}
                onSuccess={() => onUpdate?.()}
            />
            <ChargeModal
                connectAccountInfo={connectAccountInfo}
                providerId={getUserId()}
                clientId={clientId}
                billingPolicy={billingPolicy?.sort((a, b) => a.id - b.id)}
                open={showChargePatientModal}
                onCancel={() => setShowChargePatientModal(false)}
                onSuccess={() => {
                    setShowChargePatientModal(false);
                }}
            />
            <IntakeFormDrawer
                show={showIntakeFormDrawer}
                onClose={() => {
                    setShowIntakeFormDrawer(false);
                }}
                textVisitDetail={currentItemType === 'TEXT_VISIT' ? textVisitDetail : undefined}
                appointmentTreatmentDetail={currentItemType === 'APPOINTMENT' ? appointmentTreatmentDetail : undefined}
            />
        </div>
    );
};

export default ListContent;
